import ConversationListBody from './ConversationListBody';

const NavSidebar = () => {
  return (
    <div className="flex h-full flex-col">
      <ConversationListBody />
    </div>
  );
};

export default NavSidebar;
